export const COMMON_TEST_ID = {
    LIST_ITEM_CARD: 'list_item_card',
    LIST_ITEM_CARD_OVERLAY: 'list_item_card_overlay',
    COLLAPSIBLE_BUTTON: 'collapsible-button',
    ALERT_CONTAINER: 'alert--container',
    PROGRESS_BAR: 'progress-bar',
    TOOLTIP_ANCHOR: 'tooltip-anchor',
    ICON: 'icon',
    TABS_WRAPPER: 'tabs_wrapper',
    DROPDOWN_LIST: 'dropdown_list',
    DROPDOWN_TOGGLE_CARET: 'dropdown_toggle_caret',
    TOOLTIP: 'tooltip',
};
